import { connect } from '@atlassian/jira-react-redux';
import mapDispatchToProps from './command';
import mapStateToProps from './query';
import View from './view';

// @ts-expect-error - Argument of type '({ isScrolling, isReadOnly, issue, issue: { team: teamId, level, id: issueId }, showOptimizations, sprints, sprintsByTeam, teamsById, additionalTeamsById, issueStatuses, teams, sprintsByIssueSources, externalSprintsById, allSprints, rollupValues, SprintSelectComponent, onChange, }: Props) => JSX.Element' is not assignable to parameter of type 'ComponentType<Matching<Partial<Props> & {}, Props>>'.
export default connect(mapStateToProps, mapDispatchToProps)(View);
